import { TimePicker, Space, Button, Divider } from "antd";
import { FilterOutlined, ReloadOutlined } from "@ant-design/icons";

const { RangePicker } = TimePicker;

const TimeRangeFilter = ({
  setSelectedKeys,
  selectedKeys,
  confirm,
  clearFilters,
}) => {
  const handleChange = (times) => {
    if (times && times.length === 2) {
      // Keep as dayjs objects
      setSelectedKeys(times);
    } else {
      setSelectedKeys([]);
    }
  };

  const handleReset = () => {
    setSelectedKeys([]);
    clearFilters();
    confirm();
  };

  const handleApply = () => {
    if (selectedKeys && selectedKeys.length === 2) {
      confirm();
    }
  };

  const isDisabled = !selectedKeys || selectedKeys.length !== 2;

  return (
    <div style={{ padding: 16, width: 280 }}>
      <div style={{ marginBottom: 12, fontWeight: 500, color: "#333" }}>
        <FilterOutlined style={{ marginRight: 8 }} />
        Select Time Range
      </div>

      <div style={{ fontSize: 12, color: "#999", marginBottom: 4 }}>
        Start Time — End Time
      </div>
      
      <RangePicker
        style={{ width: "100%" }}
        value={selectedKeys}
        onChange={handleChange}
        format="HH:mm:ss"
        placeholder={["HH:MM:SS", "HH:MM:SS"]}
        allowClear
        suffixIcon={null}
        showNow={false}
      />

      {/* Show preview of selected time */}
      {selectedKeys && selectedKeys.length === 2 && (
        <div style={{ 
          marginTop: 8, 
          padding: "6px 10px", 
          background: "#f5f5f5", 
          borderRadius: 4,
          fontSize: 13,
          color: "#333",
          display: "flex",
          justifyContent: "space-between"
        }}>
          <span>⏱ From</span>
          <span style={{ fontWeight: 500 }}>
            {selectedKeys[0].format("HH:mm:ss")} — {selectedKeys[1].format("HH:mm:ss")}
          </span>
        </div>
      )}

      <Divider style={{ margin: "12px 0" }} />

      <Space style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
        <Button
          icon={<ReloadOutlined />}
          size="small"
          onClick={handleReset}
        >
          Reset
        </Button>

        <Button
          type="primary"
          icon={<FilterOutlined />}
          size="small"
          onClick={handleApply}
          disabled={isDisabled}
        >
          Apply
        </Button>
      </Space>

      {isDisabled && (
        <div style={{ marginTop: 6, fontSize: 11, color: "#ff4d4f" }}>
          Please select both start and end time
        </div>
      )}
    </div>
  );
};

export default TimeRangeFilter;